import React from 'react';
import { getAudienceMetricThresholdMap } from '@components/noc-metric-panel/utils/constants';
import ScopeV2 from '../ThresholdV2/Scope';
import SearchHeader from '../ThresholdV2/SearchHeader';
import { getMetricDisplayName, getMetricShortName } from '@utils/metrics';

export const mainBaseLineColumnV2 = [
  {
    title: '',
    key: 'BaseLine',
    dataKey: 'BaseLine',
    width: 260,
    frozen: true,
    style: {
      fontSize: '18px',
      position: 'relative',
      top: '10px',
    },
  },
];

export const mainContentColumnV2 = [
  {
    title: '',
    key: 'RowKeys',
    dataKey: 'RowKeys',
    width: 260,
    cellRenderer: (props) => {
      const { cellData } = props;
      return <ScopeV2 text={cellData} />;
    },
    headerRenderer: () => <SearchHeader />,
    frozen: true,
  },
];

export const getThresholdBaselineColumns = () => {
  const cols = [] as Record<string, any>;
  const audienceMetricThresholdMap = getAudienceMetricThresholdMap();
  Object.entries(audienceMetricThresholdMap).map(([baselineMetricKey, data]) => {
    const audienceMetricNames = data.metrics
      .map((it) => {
        return getMetricShortName({
          metricKey: it,
          hasSubscript: false,
        });
      })
      .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

    cols.push({
      key: baselineMetricKey,
      width: 600,
      labelAttributes: {
        prefixs: audienceMetricNames,
        suffix: getMetricDisplayName({
          metricKey: baselineMetricKey,
        }),
      },
    });
  });
  return { cols };
};
